import { GET_FACILIDADES } from './mutation-types'
import facilidadesHttpServices from '../_services/facilidadesHttpServices'

export default {
  listarFacilidades: async ({ commit }) => {
    try {
      const response = await facilidadesHttpServices.getFacilidades()
      commit(GET_FACILIDADES, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
